import { render, staticRenderFns } from "./AddContentToCollectionsModal.vue?vue&type=template&id=1a7ddd0e&lang=pug&"
import script from "./AddContentToCollectionsModal.vue?vue&type=script&lang=js&"
export * from "./AddContentToCollectionsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports